import { Field, Input, Label } from '@headlessui/react'
import { dbService } from './db';
import React, { useRef, useState, useEffect } from 'react';
import { Form, Link, useSubmit, useLoaderData  } from "react-router";

export function meta({ }) {
  return [
    { title: "DX Sales App - Customers" },
    { name: "description", content: "Welcome to DX Sales App - Customers" },
  ];
}

export async function clientLoader({
  params, request
}) {
  let db = await dbService.createDB();
  const url = new URL(request.url);
  const searchString = url.searchParams.get("searchString");
  var customers = [];

  if (!searchString) {

  } else {
    const index = db.transaction('customers').store.index('nameIndex');
    const keyRangeValue = IDBKeyRange.bound("A", "z", true, true);
    let x = await db.getAll("customers");
    customers = x.filter((customer) => customer.name.toLowerCase().includes(searchString.toLowerCase()));
  }
  //customers = await db.getAll("customers");
  return { customers, searchString };
}

export function Customers({ }) {
  const { customers, searchString } = useLoaderData();
  const submit = useSubmit();

  useEffect(() => {
    const searchField = document.getElementById("searchField");
    if (searchField instanceof HTMLInputElement) {
      searchField.value = searchString || "";
    }
  }, [searchString]);
  return (
    <>
      <Form id="searchForm"
        onChange={(event) =>
          submit(event.currentTarget)
        }>
        <Field>
          <Label className={"text-sm/6 font-medium text-gray-900"}>Search</Label>
          <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800">
            <Input defaultValue={searchString || ""} name="searchString" id="searchField" placeholder="Search" className={"block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"} />
          </div>
        </Field>
      </Form>

      <div>
        {customers && customers.slice(0, 6).map((x, i) =>
          <Link key={x.customerNumber} to={`/customers/${x.customerNumber}`} className="block bg-white p-2 outline-gray-800 m-2 border border-gray-800 rounded-sm">
            <span className="block p-0 m-0 text-gray-800">{x.name}</span>
            <span className="text-xs italic font-semibold text-red-800">{x.customerNumber}</span>
          </Link>
        )}
      </div>
    </>
  );
}